import { FaIcon, NonIdealState } from '@acp/core-ui';
import { Button, VStack } from '@chakra-ui/react';
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons';
import { AccessIssuesWizardMachineContext } from '../machine/context';

function AccessIssuesWizardErrorScreen({
    title,
    description,
}: {
    title: string;
    description: string;
}) {
    const machine = AccessIssuesWizardMachineContext.useActorRef();

    return (
        <VStack minH="96" justifyContent="center">
            <NonIdealState
                iconComponent={<FaIcon w={12} h={12} icon={faExclamationCircle} color="danger.500" />}
                title={title}
                description={description}
                titleFontSize="lg"
            >
                <Button
                    colorScheme="blackAlpha"
                    bgColor="black"
                    size="md"
                    onClick={() => machine.send({ type: 'CLOSE_MODAL' })}
                >
                    Close
                </Button>
            </NonIdealState>
        </VStack>
    );
}

export { AccessIssuesWizardErrorScreen };
